import React from 'react';
import PropTypes from 'prop-types';
import isRequiredIf from 'react-proptype-conditional-require';
import classnames from 'classnames';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import Span from '@deliveroo/consumer-component-library/components/Span';
import greyTile from './images/grey.svg';

import styles from './styles.scss';

const FilterShortcut = ({ name, onClick, images, isPlaceholder, lazyLoader }) => (
  <button
    className={classnames(styles['filter-shortcut'], {
      [styles.placeholder]: isPlaceholder,
    })}
    type="button"
    onClick={onClick}
  >
    {!isPlaceholder && (
      <BackgroundImage
        src={(images && `${images.default}&auto=webp&format=png`) || greyTile}
        lazyLoader={lazyLoader}
      >
        <span className={styles.name}>
          <Span color="white" isBold>
            {name}
          </Span>
        </span>
      </BackgroundImage>
    )}
  </button>
);

FilterShortcut.propTypes = {
  name: isRequiredIf(PropTypes.string, (props) => !props.isPlaceholder),
  images: isRequiredIf(
    PropTypes.shape({
      default: PropTypes.string.isRequired,
    }),
    (props) => !props.isPlaceholder,
  ),
  onClick: isRequiredIf(PropTypes.func, (props) => !props.isPlaceholder),
  lazyLoader: PropTypes.shape({
    isSupported: PropTypes.bool.isRequired,
    observe: isRequiredIf(PropTypes.func, (props) => props.isSupported),
    unobserve: isRequiredIf(PropTypes.func, (props) => props.isSupported),
  }),
  isPlaceholder: PropTypes.bool,
};

FilterShortcut.defaultProps = {
  name: undefined,
  images: undefined,
  onClick: undefined,
  lazyLoader: undefined,
  isPlaceholder: false,
};

FilterShortcut.placeholderProps = {
  onClick: () => undefined,
};

export default FilterShortcut;
